module.exports = __webpack_public_path__ + "img/payment-success.88f0f6ea.svg";